import React from 'react';

import ChevronDownIcon from '@flipster/react/icon/generated/ChevronDownIcon';
import { css } from '@flipster/styled-system/css';
import { center, hstack } from '@flipster/styled-system/patterns';
import segment from '@flipster/utils/segment';
import { MainEvent } from '@flipster/utils/segment/events/main';

interface Props {
  index: number;
  title: string;
  children: React.ReactNode;
}

const Collapsible = ({ index, title, children }: Props) => {
  return (
    <details
      className={css({
        px: { base: 16, tablet: 24 },
        py: { base: 16, tablet: '32' },
        borderBottom: '1px solid',
        borderColor: 'border.default.level-2',
        '&[open] summary svg': {
          transform: 'rotate(-180deg)',
        },
      })}
    >
      <summary
        role='button'
        tabIndex={0}
        className={hstack({
          justify: 'space-between',
          gap: 12,
          cursor: 'pointer',
          '&::-webkit-details-market': { display: 'none' },
        })}
        onClick={() => segment.track(MainEvent.MainPageFaqClick, { list_order: index, question_name: title })}
      >
        <div className={hstack({ gap: { base: 12, tablet: 20 }, flex: 1 })}>
          <span
            className={center({
              textStyle: 'Text/M/Strong',
              color: 'content.default.level-4',
              border: '1px solid',
              borderColor: 'border.default.level-2',
              w: 32,
              h: 32,
              rounded: 4,
            })}
          >
            {index + 1}
          </span>
          <h3 className={css({ textStyle: 'Title/S', color: 'content.default.level-5', flex: 1 })}>{title}</h3>
        </div>
        <ChevronDownIcon />
      </summary>
      <div className={css({ mt: { base: 12, tablet: 20 } })}>{children}</div>
    </details>
  );
};

export default Collapsible;
